/* lunatic. — thème v2 : animations (vanilla, sans dépendance) */
(function () {
  'use strict';
  var root = document.documentElement;
  root.classList.add('lv-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- apparitions au scroll ---------- */
  var reveals = Array.prototype.slice.call(document.querySelectorAll('.lv-reveal'));
  function check() {
    var limit = window.innerHeight * 0.96;
    reveals.forEach(function (e) { if (!e.classList.contains('lv-in') && e.getBoundingClientRect().top < limit) e.classList.add('lv-in'); });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('lv-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (e) { io.observe(e); });
  }
  check(); setTimeout(check, 400);
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check);

  /* ---------- navigation ---------- */
  var nav = document.querySelector('.lv-nav');
  function onScrollNav() { if (nav) nav.setAttribute('data-scrolled', window.scrollY > 8 ? 'true' : 'false'); }
  onScrollNav(); window.addEventListener('scroll', onScrollNav, { passive: true });
  var menu = document.querySelector('.lv-menu');
  document.querySelectorAll('[data-lv-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu.setAttribute('data-open', 'true'); menu.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }); });
  document.querySelectorAll('[data-lv-menu-close]').forEach(function (b) { b.addEventListener('click', function () { menu.setAttribute('data-open', 'false'); menu.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }); });

  /* ---------- curseur étoile ---------- */
  var cur = document.querySelector('.lv-cursor');
  if (cur && !window.matchMedia('(hover: none)').matches) {
    var x = 0, y = 0, cx = 0, cy = 0;
    window.addEventListener('pointermove', function (e) {
      x = e.clientX; y = e.clientY; cur.setAttribute('data-on', 'true');
      var t = e.target && e.target.closest ? e.target.closest('a, button, input, [data-hot]') : null;
      cur.setAttribute('data-hot', t ? 'true' : 'false');
    });
    document.documentElement.addEventListener('mouseleave', function () { cur.setAttribute('data-on', 'false'); });
    (function loop() { cx += (x - cx) * 0.22; cy += (y - cy) * 0.22; cur.style.left = cx + 'px'; cur.style.top = cy + 'px'; requestAnimationFrame(loop); })();
  }

  /* ---------- hero : orbites ---------- */
  var orbit = document.querySelector('.lv-orbit');
  if (orbit) {
    var C = 360;
    var RINGS = [
      { rx: 345, ry: 190, rot: -22, speed: 0.11 },
      { rx: 215, ry: 330, rot: 18, speed: -0.16 }
    ];
    var ringsEl = orbit.querySelector('[data-rings]');
    var bodies = Array.prototype.slice.call(orbit.querySelectorAll('.lv-orbit__body')).map(function (el) {
      return { el: el, ring: parseInt(el.getAttribute('data-ring') || '0', 10), phase: parseFloat(el.getAttribute('data-phase') || '0') };
    });
    function pointOn(ring, theta, extra) {
      var a = (ring.rot + extra) * Math.PI / 180, px = ring.rx * Math.cos(theta), py = ring.ry * Math.sin(theta);
      return { x: C + px * Math.cos(a) - py * Math.sin(a), y: C + px * Math.sin(a) + py * Math.cos(a) };
    }
    var t0 = performance.now();
    (function tick(now) {
      var t = reduce ? 0 : (now - t0) / 1000;
      var scrollRot = Math.min(window.scrollY, 1200) * 0.03;
      if (ringsEl) ringsEl.setAttribute('transform', 'rotate(' + scrollRot + ' ' + C + ' ' + C + ')');
      bodies.forEach(function (b) {
        var ring = RINGS[b.ring] || RINGS[0];
        var p = pointOn(ring, b.phase + t * ring.speed, scrollRot);
        var W = orbit.clientWidth || 720;
        b.el.style.transform = 'translate3d(' + (p.x / 720 * W).toFixed(2) + 'px,' + (p.y / 720 * W).toFixed(2) + 'px,0) translate(-50%,-50%)';
      });
      requestAnimationFrame(tick);
    })(t0);
  }

  /* ---------- parallaxe croisée (atelier) ---------- */
  var story = document.querySelector('.lv-story');
  if (story && !reduce) {
    var phA = story.querySelector('[data-parallax="a"]'), phB = story.querySelector('[data-parallax="b"]');
    function par() {
      var r = story.getBoundingClientRect();
      var p = (window.innerHeight - r.top) / (window.innerHeight + r.height) - 0.5;
      if (phA) phA.style.transform = 'translateY(' + (p * -70) + 'px)';
      if (phB) phB.style.transform = 'translateY(' + (p * 70) + 'px)';
    }
    par(); window.addEventListener('scroll', function () { requestAnimationFrame(par); }, { passive: true });
  }

  /* ---------- texte sur ellipse : remplir tout le chemin ---------- */
  document.querySelectorAll('[data-fill-path]').forEach(function (tp) {
    try {
      var path = document.getElementById(tp.getAttribute('href').slice(1) || tp.getAttribute('xlink:href').slice(1));
      var len = path.getTotalLength();
      var base = tp.getAttribute('data-fill-path');
      var probe = tp.textContent = base;
      var w = tp.getComputedTextLength();
      if (w > 0) { var n = Math.max(1, Math.floor(len / w)); tp.textContent = new Array(n + 1).join(base); tp.setAttribute('textLength', len); tp.setAttribute('lengthAdjust', 'spacing'); }
    } catch (e) { /* ignore */ }
  });
})();

/* ---------- fiche produit : galerie, variantes, barre mobile ---------- */
(function () {
  var root = document.querySelector('[data-lv-product]');
  if (!root) return;
  var main = root.querySelector('[data-lv-main]');
  root.querySelectorAll('[data-lv-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (main) main.src = b.getAttribute('data-full');
      root.querySelectorAll('[data-lv-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      b.setAttribute('aria-current', 'true');
    });
  });
  var variants = [];
  try { variants = JSON.parse(root.querySelector('[data-lv-variants]').textContent); } catch (e) {}
  var fmt = root.getAttribute('data-money') || '{{amount_with_comma_separator}} €';
  function money(cents) { var v = (cents / 100).toFixed(2); var s = fmt.indexOf('comma_separator') > -1 ? v.replace('.', ',') : v; return fmt.replace(/\{\{.*?\}\}/, s).replace(/&nbsp;/g, ' '); }
  var selected = [];
  root.querySelectorAll('[data-lv-option]').forEach(function (o, i) { var p = o.querySelector('[aria-pressed="true"]'); selected[i] = p ? p.getAttribute('data-lv-value') : null; });
  var idInput = root.querySelector('[data-lv-variant-id]'), price = root.querySelector('[data-lv-price]'), cmp = root.querySelector('[data-lv-compare]'), add = root.querySelector('[data-lv-add]'), addLabel = root.querySelector('[data-lv-add-label]');
  var atc = document.querySelector('[data-lv-atc]'), atcPrice = document.querySelector('[data-lv-atc-price]');
  var baseLabel = addLabel ? addLabel.textContent : 'ajouter au panier';
  function current() {
    return variants.find(function (v) { return selected.every(function (s, i) { return s === null || v.options[i] === s; }); });
  }
  function refresh() {
    var v = current();
    root.querySelectorAll('[data-lv-opt]').forEach(function (b) {
      var i = parseInt(b.getAttribute('data-lv-opt'), 10), val = b.getAttribute('data-lv-value');
      var ok = variants.some(function (x) { return x.available && x.options[i] === val && selected.every(function (s, j) { return j === i || s === null || x.options[j] === s; }); });
      b.disabled = !ok && !(selected[i] === val);
      b.setAttribute('aria-pressed', selected[i] === val ? 'true' : 'false');
    });
    root.querySelectorAll('[data-lv-option-label]').forEach(function (l) { l.textContent = selected[parseInt(l.getAttribute('data-lv-option-label'), 10)] || ''; });
    if (!v) { if (add) { add.disabled = true; } if (addLabel) addLabel.textContent = 'indisponible'; return; }
    if (idInput) idInput.value = v.id;
    if (price) price.textContent = money(v.price);
    if (atcPrice) atcPrice.textContent = money(v.price);
    if (cmp) { if (v.compare_at_price && v.compare_at_price > v.price) { cmp.hidden = false; cmp.textContent = money(v.compare_at_price); } else { cmp.hidden = true; } }
    if (add) add.disabled = !v.available;
    if (addLabel) addLabel.textContent = v.available ? baseLabel : 'épuisé';
    if (v.featured_image && v.featured_image.src && main) main.src = v.featured_image.src;
  }
  root.querySelectorAll('[data-lv-opt]').forEach(function (b) {
    b.addEventListener('click', function () { selected[parseInt(b.getAttribute('data-lv-opt'), 10)] = b.getAttribute('data-lv-value'); refresh(); });
  });
  if (variants.length) refresh();
  /* barre mobile : visible quand le bouton principal sort de l'écran */
  if (atc && add && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { atc.setAttribute('data-show', e[0].isIntersecting ? 'false' : 'true'); }).observe(add);
    var atcAdd = document.querySelector('[data-lv-atc-add]');
    if (atcAdd) atcAdd.addEventListener('click', function () { add.click(); });
  }
})();
